module.exports = __webpack_public_path__ + "assets/images/pages/ministerioconsumo/grid-1.webp?34550bcd";